// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__72V1i","count":"style_count__3O6oT","iconLike":"style_iconLike__3qvW_","iconDislike":"style_iconDislike__1ZzDr"};